/**
 * ProfessionalInfoCards
 * Display cards with professional's stats and information
 */

import { Card, CardContent, CardHeader, CardTitle } from '@shared/components/ui/card'
import { StarRating } from '@shared/components/ui/star-rating'
import type { Professional } from '@shared/types'
import { MessageSquare, Star } from 'lucide-react'

// ============================================================================
// Types
// ============================================================================

interface ProfessionalInfoCardsProps {
  professional: Professional
}

// ============================================================================
// Component
// ============================================================================

export function ProfessionalInfoCards({ professional }: ProfessionalInfoCardsProps) {
  return (
    <div className="flex flex-col gap-4 mb-2">

      <div className="flex rounded-xl border border-border bg-card text-card-foreground shadow-md">
        {/* Rating Card */}
        <Card className='w-1/2  rounded-none border-0 bg-transparent shadow-none'>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium flex items-center gap-2">
              <Star className="h-4 w-4 text-ring fill-ring" />
              Calificación
            </CardTitle>
          </CardHeader>
          <CardContent className='bg-transparent border-transparent'>
            <div className="flex flex-col items-center">
              <div className="text-4xl font-bold mb-2">
                {professional.averageRating.toFixed(1)}
              </div>
              <StarRating rating={professional.averageRating} size="md" />
            </div>
          </CardContent>
        </Card>

        <div className="w-px my-6 border-r border-border" />

        {/* Reviews Count Card */}
        <Card className='w-1/2 rounded-none border-none bg-transparent shadow-none'>
          <CardHeader className="pb-3">
            <CardTitle className="text-sm font-medium flex items-center gap-2">
              <MessageSquare className="h-4 w-4 text-ring" />
              Reseñas
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="text-center">
              <div className="text-4xl font-bold mb-2">{professional.totalReviews}</div>
              <p className="text-sm text-muted-foreground">
                {professional.totalReviews === 1 ? 'reseña' : 'reseñas'}
              </p>
            </div>
          </CardContent>
        </Card>

      </div>
    </div>
  )
}
